import React from "react";
import type { SliceComponentProps } from "@prismicio/react";
import type { BannerContentPageSlice } from "~/lib/prismic/types.generated";
import { asImageSrc } from "@prismicio/helpers";

const BannerContentPage = ({
  slice,
}: SliceComponentProps<BannerContentPageSlice>) => {
  const imgixParams = { q: 85, auto: "format", sharp: 10 };

  const desktopUrl = asImageSrc(slice.primary.image, imgixParams);

  if (!desktopUrl) {
    return null;
  }

  const mobileUrl = asImageSrc(slice.primary.image.mobile, imgixParams) || desktopUrl;
  const altText = slice.primary.image.alt || "";

  return (
  <div className="container px-0 px-lg-3">
    <div className="component-visual-text mb-5">
      <div className="component-visual-text__bg">
        <picture>
          <source media="(max-width: 767px)" srcSet={mobileUrl} />
          <source media="(min-width: 768px)" srcSet={desktopUrl} />
          <img src={desktopUrl} alt={altText} />
        </picture>
      </div>
    </div>
  </div>
);
};

export default BannerContentPage;
